<template>
  <button type="button" class="btn btn-link mx-auto"
          v-if="isOpen"
          v-on:click="$emit('check-delete', abstract.id, submission_id)">
    <icon :icon="['fad', 'trash-alt']" class="text-warning"/>
    <br>
    {{wording[0].buttons.delete}}
  </button>
  <button type="button" class="btn btn-link mx-auto disabled" v-else>
    <icon :icon="['fad', 'trash-alt']" class="text-warning"/>
    <br>
    {{wording[0].buttons.delete}}
  </button>
</template>
<script>
  export default {
    name: 'DeleteArea',
    props: {
      abstract: {},
      isOpen: {},
      submission_id: {},
      wording: {}
    }
  }
</script>
<style scoped>
  @media (min-width: 10em) {
  }
</style>
